var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"sidebar",class:[_vm.isOpen ? 'open' : '', _vm.wide ? 'wide' : '', _vm.device === 'mobile' ? 'full-wide' : ''],attrs:{"id":"menu-bar"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }